module.exports = __webpack_public_path__ + "media/images/use_cases/logo-testing-717f949772866a53adb43138088c02ef.png";